<template>
    <div class="container-fluid h-100">
      <div class="container mt-5 pt-5">
        <!-- Navegación -->
        <div class="col-12 mt-3 mb-3" style="text-align: center">
          <button
            v-if="view == 2"
            @click="showListProduct()"
            type="button"
            class="btn btn-success btn-md"
          >
            Listar Productos
          </button>
          <button
            v-if="view == 1"
            @click="showListDistributor()"
            type="button"
            class="btn btn-success btn-md"
          >
            Listar Distribuidores
          </button>
        </div>

        <div class="col-12 col-lg-12 mt-2" style="display:flex;">
          <div class="col-12 col-lg-4 mt-2">
            <div class="col-12 col-lg-12 mt-2">
              <button class="btn btn-info btn-block" @click="createNew()">
                Crear (Productos / Distribuidores)
              </button>
            </div>
          </div>
          <div v-if="view == 1" class="col-12 col-lg-3 mt-2" style="display:flex; margin:auto;">
            <div class="col-12 col-lg-12 mt-2" style="margin:auto 0px auto auto;">
              <button
                :hidden="hidden.btn"
                class="btn btn-danger btn-block"
                @click="clean()"
              >
                Limpiar orden
              </button>
            </div>
            <div class="col-12 col-lg-12 mt-2" style="margin:auto 0px auto auto;">
              <button
                :disabled="loading.order"
                :hidden="hidden.btn"
                class="btn btn-info btn-block "
                @click="saveOrders()"
              >
                <template v-if="loading.order">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Cargando...
                </template>
                <template v-else>Guardar orden </template>
              </button>
            </div>
          </div>
        </div>
        
        <template v-if="loading.history">
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border text-danger"
              style="width: 4em; height: 4rem;"
              role="status"
            ></div>
          </div>
        </template>
  
        <paginate
          v-else
          class="ul-pagination"
          name="items"
          :list="items"
          :per="9"
        >
          <!-- Listado de productos -->
          <div v-if="view == 1" class="row mt-1">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-sm">
                  <caption class="visually-hidden">Listado de Productos</caption>
                  <thead>
                    <tr>
                      <th scope="col" style="text-align: left">Nombre Producto</th>
                      <th scope="col" style="text-align: left">Imagen Producto</th>
                      <th scope="col" style="text-align: left">Estado Producto</th>
                      <th scope="col" style="text-align: left">Acción</th>
                    </tr>
                  </thead>
                  <draggable v-model="items" tag="tbody">
                    <tr
                      v-for="(item, i) in paginated('items')"
                      :key="'d' + `item-${i}`"
                    >
                      <td style="text-align: left">
                        {{ item.name }}
                      </td>
                      <td style="text-align: left">
                        <img
                          width="80"
                          class="img-item"
                          :src="item.image"
                          :alt="item.name"
                        />
                      </td>
                      <td style="text-align: left">
                        {{ item.status_id == 1 ? "Activo" : "Inactivo" }}
                      </td>
                      <td style="text-align: left">
                        <label @click="editProduct(item)" v-if="item.status_id == 1" style="color: #dc3545; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                        <label @click="editProduct(item)" v-else style="color: gray; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </div>

          <!-- Listado de distribuidores -->
          <div v-if="view == 2" class="row mt-1">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-sm">
                  <caption class="visually-hidden">Listado de Distribuidores</caption>
                  <thead>
                    <tr>
                      <th scope="col" style="text-align: left">Nombre Distribuidor</th>
                      <th scope="col" style="text-align: left">Imagen Distribuidor</th>
                      <th scope="col" style="text-align: left">Estado Distribuidor</th>
                      <th scope="col" style="text-align: left">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in paginated('items')"
                      :key="'d' + `item-${i}`"
                    >
                      <td style="text-align: left">
                        {{ item.name }}
                      </td>
                      <td style="text-align: left">
                        <img
                          width="80"
                          class="img-item"
                          :src="item.image"
                          :alt="item.name"
                        />
                      </td>
                      <td style="text-align: left">
                        {{ item.status_id == 1 ? "Activo" : "Inactivo" }}
                      </td>
                      <td style="text-align: left">
                        <label @click="editDistributor(item)" v-if="item.status_id == 1" style="color: #dc3545; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                        <label @click="editDistributor(item)" v-else style="color: gray; cursor:pointer;">
                          <span class="fa fa-duotone fa-eye"></span>
                          Editar
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </paginate>
  
        <div class="row ">
          <div
            class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
          >
            <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
          </div>
          <div
            class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
          >
            <paginate-links
              @change="pageChange"
              for="items"
              :limit="2"
              :show-step-links="true"
              :step-links="{ next: '>', prev: '<' }"
              :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
            >
            </paginate-links>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
  //import $ from "jquery";
  import axios from 'axios';
  import draggable from 'vuedraggable'
  
  export default {
    name: "listProductsWeb",
    components: {
      draggable,
    },
    data() {
      return {
        view: 1,
        loading: {
          history: false,
        },
        currentList: [],
        items: [],
        paginate: ["items"],
        page: 1,
        totalPage: 1,
        hidden: {
          btn: false
        },
      };
    },
    methods: {
      showListProduct(){
        this.view = 1;
        this.getProducts();
      },
      showListDistributor(){
        this.view = 2;
        this.getDistributors();
      },
      createNew(){
        this.$router.push({ name: "createProducts" });
      },
      getProducts(){
        this.items = [];
        this.loading.history = true;

        axios
        .get("superAdmin/get/products")
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.currentList = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
            this.items.sort((a, b) => a.product_order - b.product_order);
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      getDistributors(){
        this.items = [];
        this.loading.history = true;

        axios
        .get("superAdmin/get/sectionWeb/distributors")
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            // console.log(JSON.stringify(this.items));
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      // Editar producto
      editProduct(item){
        this.$router.push({ name: "editSectionWeb", params: { productId: item.id, view: 1 } });
      },
      // Editar distribuidor
      editDistributor(item){
        this.$router.push({ name: "editSectionWeb", params: { distributorId: item.id, view: 2 } });
      },
      pageChange(toPage) {
        this.page = toPage;
      },
      saveOrders() {
        var listOrders = [];
        var cont = 0;
        for (let i = 0; i < this.items.length; i++) {
          listOrders.push({
            id: this.items[i].id,
            order: cont++
          });
        }
        var data = {
          orders: listOrders
        };
        // console.log('data: ', JSON.stringify(data));
        this.loading.order = true;
        axios
          .post("superAdmin/products/setOrders", data)
          .then(res => {
            if (res.data.cod == 0) {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message
              });
              this.hidden.btn = true;
              this.getProducts();
            }
            this.loading.order = false;
          })
          .catch(error => {
            this.loading.order = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      clean() {
        this.items = this.currentList;
      },
    },
    mounted() {
      this.pageChange(1);
      this.getProducts();
    },
    watch: {
      items: function(newL) {
        var cont = 0;
        // console.log('this.currentList ', JSON.stringify(this.currentList));
        for (let i = 0; i < this.currentList.length; i++) {
          if (this.currentList[i].id != newL[i].id) {
            cont++;
          }
        }
        if (cont > 0) {
          this.hidden.btn = false;
        } else {
          this.hidden.btn = true;
        }
      },
    }
  };
</script>

<style scoped>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
  }
  .div-button {
    margin-top: 50px;
    text-align: left;
  }
  .is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
  }
  .modal-title {
    color: black;
    font-weight: bold;
  }
  .modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
  }
  label {
    color: black;
    margin-right: 4px;
  }
  .img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
  }
  td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
  }
  .table-container {
    overflow: auto;
  }
  h5 {
    margin-bottom: 10px !important;
  }
  .commentary {
    text-align: left;
    color: #1da5df;
    font-size: 13px;
  }
  .page-item.active .page-link {
    border-style: none;
    border-radius: 20px;
    background-color: #dc3545;
  }
  a.page-link {
    color: black;
    cursor: pointer;
  }
  a.page-link:hover {
    color: #dc3545;
  }
  .page-link {
    background-color: #f5f5dc00;
    border-radius: 20px;
    border-color: none;
  }
  .page-item.disabled .page-link {
    color: #dc3545;
    background-color: #fff0;
    border-color: #dee2e600;
  }
  .ul-pagination {
    padding: 0px;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>
  